import { memo } from 'react';

import { CUSTOM_ITEM_DETAIL_IMAGE, CUSTOM_ITEM_THUMBNAIL_IMAGE } from '../lib/relationships';
import { BadgeColor, BadgeType, DeliveryItem } from '../lib/types';
import { Badge, Colors, StyleProps } from './general';

type AddItemProps = { text: string; description?: string; onClick: () => void } & StyleProps;

const Add: React.FC<AddItemProps> = ({ text, description, onClick, className }) => {
  return (
    <div
      className={`bg-white hover:bg-gray-50 h-28 lg:h-32 flex items-center lg:border cursor-pointer ${className}`}
      onClick={onClick}
    >
      <div className="flex flex-col items-start justify-center mx-4">
        <p className="text-sm lg:text-base font-medium">{text}</p>
        {description && <p className={`text-sm text-${Colors.secondaryText} mt-1`}>{description}</p>}
      </div>
      <div className="ml-auto h-20 lg:h-full w-20 lg:w-36 flex items-center justify-center flex-shrink-0">
        <div
          className="w-full h-full bg-contain bg-center bg-no-repeat mr-4 lg:hidden"
          style={{ backgroundImage: `url(${CUSTOM_ITEM_THUMBNAIL_IMAGE})` }}
        />
        <div
          className="w-full h-full bg-cover bg-no-repeat hidden lg:block"
          style={{ backgroundImage: `url(${CUSTOM_ITEM_DETAIL_IMAGE})` }}
        />
      </div>
    </div>
  );
};

export const AddItem = memo(Add);

type MenuItemProps = { badge?: boolean; item: DeliveryItem; onClick: (item: DeliveryItem) => void } & StyleProps;

export const Item: React.FC<MenuItemProps> = ({ badge, item, className, onClick }) => {
  return (
    <div
      className={`flex items-center cursor-pointer bg-white hover:bg-gray-50 h-28 lg:h-32 lg:border ${className}`}
      onClick={() => onClick(item)}
    >
      <div className="flex flex-col items-start justify-center mx-4">
        <p className="text-sm lg:text-base font-medium">{item.name}</p>
        {item.description && (
          <p className={`text-sm text-${Colors.secondaryText} mt-1 line-clamp overflow-hidden`}>{item.description}</p>
        )}
        {badge && false ? <Badge className="mt-2" color={BadgeColor.pink} type={BadgeType.popular} /> : null}
      </div>
      <div className="ml-auto h-20 lg:h-full w-20 lg:w-36 flex items-center justify-center flex-shrink-0">
        <div
          className="w-full h-full bg-contain bg-center bg-no-repeat mr-4 lg:hidden"
          style={{ backgroundImage: `url(${item.imageUrl})` }}
        />
        <div
          className="w-full h-full bg-cover bg-no-repeat hidden lg:block"
          style={{ backgroundImage: `url(${item.coverImageUrl})` }}
        />
      </div>
    </div>
  );
};

export const MenuItem = memo(Item);
